import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DesktopDigitalLms from './desktop/DesktopDigitalLms';
import MobileDigitalLms from './mobile/MobileDigitalLms';
import TabletDigitalLms from './tablet/TabletDigitalLms';

const getDeviceLayout = () => {
  if (typeof window === 'undefined') return 'desktop';

  const hasCoarsePointer = window.matchMedia?.('(pointer: coarse)').matches;
  const hasTabletTouch = (navigator.maxTouchPoints || 0) > 1;

  if (window.innerWidth < 768) return 'mobile';
  if (window.innerWidth < 1200 || hasCoarsePointer || hasTabletTouch) return 'tablet';
  return 'desktop';
};

function DigitalLms() {
  const navigate = useNavigate();
  const [deviceLayout, setDeviceLayout] = useState(getDeviceLayout);

  useEffect(() => {
    const handleResize = () => setDeviceLayout(getDeviceLayout());
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  const closeLms = () => navigate('/menu');

  if (deviceLayout === 'mobile') {
    return <MobileDigitalLms onClose={closeLms} />;
  }

  if (deviceLayout === 'tablet') {
    return <TabletDigitalLms onClose={closeLms} />;
  }

  return <DesktopDigitalLms onClose={closeLms} />;
}

export default DigitalLms;
